import React from 'react';
import {Bars3BottomLeftIcon} from '@heroicons/react/24/outline';

import EditorToolbox from '../../../toolboxes/Editor.Toolbox';
import EditorContentParagraph from './Editor.Content.Paragraph';

interface IEditorToolboxParagraphProps {}

const EditorToolboxParagraph = ({}: IEditorToolboxParagraphProps) => {
  return (
    <EditorToolbox icon={<Bars3BottomLeftIcon />} text="Paragraph">
      <EditorContentParagraph />
    </EditorToolbox>
  );
};

export default React.memo(EditorToolboxParagraph);
